export default String.raw`.news{padding:0 32px}.news__swiper{overflow-x:visible}.news__arrows{visibility:hidden}.news__slide{width:40%}`